import { Component, OnInit } from '@angular/core';
import { MediaService } from "../media/media.service";
import { LookupService } from "../webservice/lookup.service";
import { environment } from "environments/environment";
import { PlatformLocation } from '@angular/common';
import { RestService } from 'app/webservice/rest.service';

@Component({
  selector: 'app-media-modal',
  templateUrl: './media-modal.component.html',
  styleUrls: ['./media-modal.component.css']
})
export class MediaModalComponent implements OnInit {

  public serviceStackUrl;
  public mediaInfo = {};
  public assetType = '';
  public categories = [];
  public statuses = [];
  public seriesTypes = [];
  public lookupsLength: string = '';

  constructor(
    private _mediaService: MediaService, 
    private _lookup: LookupService, 
    private _restService: RestService,
    platformLocation: PlatformLocation
  ) {
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
    
    this._mediaService.selectedAsset.subscribe(asset => {
      if (asset) {
        this.assetType = asset.AssetType;
        this.mediaInfo = asset;
        console.log(this.mediaInfo);
      }
    });

    this.lookupsLength = JSON.parse(localStorage.getItem("lookups"));
    if (!this.lookupsLength || !this.lookupsLength.length) {
      this.getLookups();
    } else {
      this.categories=this._lookup.findLookupByLookupName('AssetCategory');
      this.statuses=this._lookup.findLookupByLookupName('AssetStatus');
      this.seriesTypes = this._lookup.findLookupByLookupName('Series');
    }
  }

  ngOnInit() {
  }

  getLookups() {
    let url = this.serviceStackUrl + "CCLibrary-GetLookups";
    this._restService.post(url).then(response => {
      this._lookup.lookups.next(response.Lookups);
      this.categories=this._lookup.findLookupByLookupName('AssetCategory');
      this.statuses=this._lookup.findLookupByLookupName('AssetStatus');
      this.seriesTypes = this._lookup.findLookupByLookupName('Series');
    })
  }

  getSeries(seriesId) {
    let series = this.seriesTypes.filter( function(item){return (item.Oid==seriesId);} );
    if (series[0]) {
      return series[0].Value;
    }
  }

  getCategory(categoryId) {
    let category = this.categories.filter( function(item){return (item.Oid==categoryId);} );
    if (category[0]) {
      return category[0].Value;
    }
  }

  getStatus(statusId) {
    console.log(statusId);
    let status = this.statuses.filter( function(item){return (item.Oid==statusId);} );
    console.log(status);
    console.log(this.statuses);
    if (status[0]) {
      return status[0].Value;
    }
  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/media-modal/media-modal.component.ts